'use strict';
var $export   = require('./_export')
  , $includes = require('./_array-includes')(true);

$export($export.P, 'Array', {
  // https://github.com/domenic/Array.prototype.includes
  includes: function includes(el /*, fromIndex = 0 */){
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

require('./_add-to-unscopables')('includes');


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-helmet/~/core-js/modules/es7.array.includes.js
 ** module id = 1238
 ** module chunks = 0
 **/